<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!-- تب‌های بالای پیش‌نمایش -->
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true">مشاهده QR</v-tab>
            <v-tab :ripple="true">پیش‌نمایش</v-tab>
            <v-tab :disabled="e6 <= 1" :ripple="true">تعرفه‌ها</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <!-- بخش پیش‌نمایش موبایل و QR -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <!-- تب ۱: کیوآر کد -->
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" :svg="svgMade" />
                <v-btn class=" mt-3 btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}
                </v-btn>
              </div>
            </v-tab-item>

            <!-- تب ۲: لندینگ اختصاصی موبایل روبیکا -->
            <v-tab-item>
              <robika-mobile-preview
                v-model="cardTexts"
                :orders.sync="cardTexts.orders"
                :qr-svg-data-url="qrSvgDataUrl"
                :address="`${info?.domain?.name || 'qrland.in/'}${info?.identifier}`"

              />
            </v-tab-item>

            <!-- تب ۳: تعرفه‌ها -->
            <v-tab-item v-if="!!info?.id && e6 > 1">
              <Tariffs :id_qr="info.id" :qrtype="'qrrobika'" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله اول: نام و آدرس کیوآر -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p class="font-weight-bold">وارد کردن اطلاعات کیوآر کد پیام‌رسان روبیکا</p>
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="عنوان کیوآر روبیکا"
                    placeholder="مثال: کانال ارتباط با روبیکا"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="عنوان کیوآر"
                  />
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    label="آدرس کیوآر"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #00aa55"
                  @click="markQr"
                />
              </div>
            </v-stepper-content>

            <!-- مرحله دوم: آکاردئون آیتم‌ها با list-expansion -->
            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
              <p class="font-weight-bold">تنظیمات و اطلاعات پیام‌رسان روبیکا</p>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>

              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #00aa55"
                  @click="qrUpdate(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <!-- ساخت QR کد پنهان برای خروجی وکتور -->
          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>

          <!-- مدال دانلود نهایی -->
          <custom-popup
            v-model="showDialog"
            :cons="cons"
            hide-confirm
            max-width="900"
            transition="dialog-bottom-transition"
          >
            <template v-slot:helpinfo>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-show-download-d`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="دانلود کیوآر"
              />
            </template>
            <v-card class="pa-5">
              <download-file-with-api
                v-if="showDialog"
                :address="`${info?.domain?.name || 'qrland.in/'}${info?.identifier}`"
                :visit-name="cardTexts.visitName"
                @close="showDialog = false"
                :qr_id="info?.qrId"
              />
            </v-card>
          </custom-popup>
        </v-col>
      </v-row>
    </template>
      <QrIntroModal
        storageKey="RubikaQrIntroSeen"
        title="کیوآر روبیکا"
        :pro="false"
        icon="mdi-comment-account"
        iconColor="red darken-2"
        :description="introText"
      />

  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import RobikaMobilePreview from "./component/robikaMobilePreview.vue";
import QrIntroModal from "../../QrIntroModal.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "IndexRobika",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrMaker,
    QrAddressField,
    NextBtn,
    ListExpansion,
    QrCodeMake,
    DownloadFileWithApi,
    Tariffs,
    RobikaMobilePreview,
    QrIntroModal,
    AtomSpinner
  },

  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      introText: `
        <strong>کیوآر اختصاصی پیام‌رسان روبیکا</strong> ابزاری مدرن و جذاب برای اتصال مخاطبان به کانال، صفحه روبینو یا فضای کسب‌وکار شما در پلتفرم پرمخاطب روبیکاست.
        <br><br>
        <strong>امکانات این صفحه:</strong>
        <br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. ورود مستقیم و بدون واسطه:</strong> هدایت آنی و بدون قطعی کاربر به اپلیکیشن روبیکا همراه با لینک رزرو به نسخه وب روبیکا.<br>
          <strong>۲. طراحی شیک و مدرن:</strong> هماهنگ با تم جذاب و گرادیانت اختصاصی روبیکا، همراه با انیمیشن‌های شیشه‌ای و امکان آپلود لوگو و بنر هدر.<br>
          <strong>۳. معرفی کامل صفحه:</strong> درج آیدی، نام کانال یا برند، متن معرفی و دکمه‌های ورود سفارشی‌سازی شده برای ایجاد بیشترین نرخ تبدیل (عضویت).
        </span>
        <br>
        راهکاری ایده‌آل برای بنرهای تبلیغات محیطی، کارت‌های ویزیت، تراکت‌ها و رشد سریع جامعه مخاطبان در روبیکا.
      `,

      helpData: [],
      svgMade: "",
      serviceName: "Qrland",
      componentName: "indexrobika",
      e6: 1,
      qrShow: 1,
      domainId: null,
      info: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      showDialog: false,
      loading: false,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر روبیکا" },
      qrSvgDataUrl: "",
cardTexts: {
  visitName: "پیام‌رسان روبیکا",
  orders: [
    { name: "robikaBaseInfo" },
    { name: "photo" },
    { name: "robikaActions" },
    { name: "pallete" },
  ],
  robikaId: "qrland999",
  organizationName: "کانال رسمی روبیکا",
  subtitle: "به کانال رسمی ما در پیام‌رسان روبیکا خوش آمدید.",
  aboutUs: "جهت دسترسی سریع و استفاده از خدمات یا عضویت در کانال، یکی از گزینه‌های زیر را لمس کنید.",
  appButtonText: "ورود به اپلیکیشن روبیکا",
  webButtonText: "مشاهده در نسخه وب روبیکا",
  desktopAction: "landing",
  pallete: {
    headColor: "linear-gradient(135deg, #7c25c7 0%, #e52d8c 100%)",
    btnColor: "linear-gradient(135deg, #7c25c7 0%, #e52d8c 100%)",
    bodyColor: "linear-gradient(180deg, #1c0a35 0%, #0f051d 100%)",
    textColor: "#ffffff",
    borderColor: "#e52d8c",
  },
  photo: {
    profile: "/media/socialnetwork/icon/robika.webp",
    transition: "scale",
    hasWelcome: false,
    showWelcome: false,
    hasGif: false,
    hasGame: false,
    previewerQr: {
      previewer: {
        gif: "",
        game: {},
        transition: "scale",
      },
    },
  headBackground: "https://cdn.terminalads.com/upload/2220b4fa3a7d5059b64192ae6fd23138.webp",
  },
},

      specialInfo: [
        {
          name: "robikaBaseInfo",
          value: "",
          title: "اطلاعات کانال / کاربری روبیکا",
          icon: "chat-processing",
        },
        {
          name: "imageUploader",
          value: "",
          title: "لوگو/ تصویر هدر",
          icon: "camera-plus",
          model: "photo",
        },
        {
          name: "robikaActions",
          value: "",
          title: "تنظیمات دکمه‌ها و ریدایرکت",
          icon: "cellphone-link",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
    };
  },

  computed: {
    fullLink() {
      return (
        (this.createdDomain?.replace("/", "") || "qrland.in") +
        "/" +
        (this.createdId || "")
      );
    },
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    if (this.$coreApi3) {
      this.cardTexts.photo.profile =
        this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    }
  },

  methods: {
    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "qrrobika",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId
          )?.name;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.qrShow = 0;
          this.$toast.success("کیوآر پیام‌رسان روبیکا با موفقیت ساخته شد.");

          if (this.e6 === 1) {
            this.e6 = 2; 
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
                this.qrShow = 1;
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response?.status === 422) {
            this.$modal.error("خطا", response.data.message);
          }
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(([fieldKey, fieldMessages]) => {
              try {
                translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                  const key = errorMap[msg];
                  return key ? this.$t(key) : msg;
                });

                const msg = fieldMessages[0];
                const key = errorMap[msg];
                this.$toast.error(key ? this.$t(key) : msg, {
                  timeout: 3000,
                });
              } catch (e) {
                console.log("Error in mapping translation: ", e);
              }
            });

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }      
      const data = new FormData();
      data.append("type", "qrrobika");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain || "");
      data.append("identifier", this.createdId || "");
      data.append("qr_id", this.info?.qrId || "");
      data.append("_method", "PUT");
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        })
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          if (final) {
            this.goto("qr/list");
            this.$toast.success("کیوآر روبیکا با موفقیت ویرایش شد.");
          }
        })
        .catch(() => {
          this.$toast.error("خطا در به‌روزرسانی کیوآر");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving =false;
        });
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
